import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ContactProps } from '@/shared/prop-types/ChatProps';
import moment from 'moment';

const contactClass = active => classNames({
  chat__contact: true,
  'chat__contact--active': active,
});

const ChatUser = ({ contact, active }) => {
  let lastMessage = '';
  if (contact) {
    lastMessage = contact?.title;
  } else {
    lastMessage = 'new contact';
  }


  return (
    <div className={`${contactClass(active)} ${active? "bg-warning": ""}`}>
      <div className="chat__contact-avatar">
        <img src={contact?.customerInfo?.avatar ? contact?.customerInfo?.avatar : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png" } alt="ava" />
      </div>
      <div className="chat__contact-preview">
        <p className="chat__contact-name">{contact?.customerInfo?.fullname}</p>
        <p className="chat__contact-post">{moment(new Date(Number(contact?.createdAt))).format('DD-MM-YYYY, h:mm:ss a')}</p>
        <p className="chat__contact-last-message">{lastMessage}</p>
      </div>
    </div>
  );
};

ChatUser.propTypes = {
  contact: ContactProps?.isRequired,
  active: PropTypes?.bool,
};

ChatUser.defaultProps = {
  active: false,
};

export default ChatUser;
